// extracted by mini-css-extract-plugin
export default {"children":"InputWithLabel_children__ew00q","addTodoInput":"InputWithLabel_addTodoInput__qFmSd"};